module.exports = __webpack_public_path__ + "static/img/21.d7bea58.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/articleProject/images/qlxj/21.png
// module id = I46f
// module chunks = 7